const NOW = new Date().getFullYear()

const FIRST_ID = NOW % 100 - 4;
const SECOND_ID = NOW % 100 - 3;
const THIRD_ID = NOW % 100 - 2;
const FOURTH_ID = NOW % 100 - 1;
const FIFTH_ID = NOW % 100;
const SIXTH_ID = NOW % 100 + 1;

const FIRST_NAME = `${NOW - 4}-${NOW % 100 - 3}`;
const SECOND_NAME = `${NOW - 3}-${NOW % 100 - 2}`;
const THIRD_NAME = `${NOW - 2}-${NOW % 100 - 1}`;
const FOURTH_NAME = `${NOW - 1}-${NOW % 100}`;
const FIFTH_NAME = `${NOW}-${NOW % 100 + 1}`;
const SIXTH_NAME = `${NOW + 1}-${NOW % 100 + 2}`;

export const DEFAULT_ID = FIFTH_ID // NOW

export  default  [
    { id: FIRST_ID, name: FIRST_NAME },
    { id: SECOND_ID, name: SECOND_NAME },
    { id: THIRD_ID, name: THIRD_NAME },
    { id: FOURTH_ID, name: FOURTH_NAME },
    { id: FIFTH_ID, name: FIFTH_NAME },
    { id: SIXTH_ID, name: SIXTH_NAME }
]